/**
 * Browser-only preferences for prescription printing.
 * Not synced to the backend — per device / profile.
 */
const RX_PRINT_AR_ON_EN_KEY = 'nw_rxPrintArPatientFreqOnEnPrescription';

export function getRxPrintArPatientFreqOnEnPrescription(): boolean {
  try {
    return localStorage.getItem(RX_PRINT_AR_ON_EN_KEY) === '1';
  } catch {
    return false;
  }
}

export function setRxPrintArPatientFreqOnEnPrescription(enabled: boolean): void {
  try {
    if (enabled) localStorage.setItem(RX_PRINT_AR_ON_EN_KEY, '1');
    else localStorage.removeItem(RX_PRINT_AR_ON_EN_KEY);
  } catch {
    /* ignore private mode / quota */
  }
}
